import { render, staticRenderFns } from "./ViewPlanPriceDetail.vue?vue&type=template&id=7f24d234&scoped=true"
import script from "./ViewPlanPriceDetail.vue?vue&type=script&lang=js"
export * from "./ViewPlanPriceDetail.vue?vue&type=script&lang=js"
import style0 from "./ViewPlanPriceDetail.vue?vue&type=style&index=0&id=7f24d234&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f24d234",
  null
  
)

export default component.exports